<template>
  <div>
    <div class="activity-stage paragraph-centered">
      <figure v-if="imageSrc">
        <img :src="imageSrc" />
      </figure>
      <div
        class="text-container"
        v-for="step in currentRound.steps"
        :key="step.stepIndex"
        :class="getTextClasses"
      >
        <blinking-cursor-text
          :text="step.answer"
          :text-step="step.stepIndex"
        ></blinking-cursor-text>
      </div>
    </div>
    <slot name="keyboard"></slot>
  </div>
</template>

<script>
import { TweenMax } from 'gsap';

import AssetLoader from 'mixins/AssetLoader';
import TypingActivityHelper from 'mixins/TypingActivityHelper';
import ActivityManager from 'mixins/ActivityManager';
import ErrorLogger from 'mixins/ErrorLogger';

import BlinkingCursorText from 'components/text-displays/BlinkingCursorText.vue';

export default {
  components: {
    BlinkingCursorText
  },
  mixins: [AssetLoader, TypingActivityHelper, ActivityManager, ErrorLogger],

  data() {
    return {
      activityName: 'Center of Attention'
    };
  },

  computed: {
    getTextClasses() {
      const textLength = this.currentRound.steps[0].answer.length;

      if (textLength > 270 && textLength < 310) {
        return 'longText';
      }

      if (textLength >= 310) {
        return 'extraLongText';
      }

      return '';
    }
  },

  beforeDestroy() {
    TweenMax.killAll();
  },

  methods: {
    async loadActivity() {
      this.createRounds(this.getActivityState());

      await this.loadImages();
    },

    async loadImages() {
      return this.downloadImages();
    },

    getActivityState() {
      const { rounds } = this.activityData;
      this.imageSrc = rounds[0].steps[0].image;
      return {
        rounds,
        instructions: {
          written: 'Type each paragraph.',
          voice: `${this.voiceInstructionsPrefix}/centerofattention-${this.getRandomVoice()}-1.mp3`,
          delay: 4
        }
      };
    },

    getKeyboardConfig() {
      return {
        hideNumberRow: !this.activityData.keyboard.showNumbers
      };
    },

    startActivity() {
      this.setupNewRound();
      this.errorLoggerStart();
      TweenMax.to('.activity-stage', 0.5, {
        autoAlpha: 1,
        onComplete: this.enableKeyboard
      });
    },

    handleCorrectKey() {
      this.sndType();
      this.incrementTypingIndex();

      if (this.isEndOfCurrentSentence) {
        this.finishStep();
      }
    },

    finishStep() {
      this.hideKeyboard();
      this.completeStep();
      this.completeActivity();
    }
  }
};
</script>

<style lang="scss" scoped>
.paragraph-centered {
  position: relative;
  .text-container {
    margin: auto;
    position: absolute;
    width: 55%;
    top: 57%;
    left: 0;
    right: 0;

    &.extraLongText {
      width: 70%;
      top: 57%;
    }
    &.longText {
      width: 65%;
      margin: 0 21%;
    }
    p {
      font-size: 18px;
    }
  }

  img {
    width: 100%;
  }
}

.tablet .paragraph-centered {
  img {
    display: block;
    margin: -15px auto;
    width: 90%;
  }
  .text-container {
    width: 50%;
    margin: 0 auto;
    &.extraLongText {
      width: 65%;
    }
  }
}
</style>
